<template>
    <div class="card-body">
        <div class="table-responsive">
            <filter-input></filter-input>
            <vuetable ref="vuetable"
                :api-url="route('admin.users.index')"
                data-path="users"
                pagination-path=""
                :append-params="moreParams"
                :css="css.table"
                :fields="fields"
                :noDataTemplate="'Datos no disponibles'"
                :sort-order="sortOrder"
            >
                <div slot="index" slot-scope="props">
                    {{ props.rowIndex + 1 }}
                </div>
                <div slot="actions" slot-scope="props">
                    <a
                        class="btn btn-primary btn-sm"
                        :href="route('admin.users.edit', props.rowData)"
                    >Editar</a>
                    <a
                        class="btn btn-danger btn-sm"
                        :class="{ 'disabled' : props.rowData.id === auth || emails.includes(props.rowData.email) }"
                        @click.prevent="handleDelete(props.rowData)"
                        :href="route('admin.users.destroy', props.rowData)"
                    >Borrar</a>
                </div>
            </vuetable>
        </div>
    </div>
</template>

<script>
    import FilterInput from '@/components/FilterInput'
    import Vuetable from 'vuetable-2'
    import VueEvents from 'vue-events'
    Vue.use(VueEvents)

    export default {
        props: {
            auth: Number,
            emails: Array,
            url: String
        },
        data() {
            return {
                css: {
                    table: {
                        tableClass: 'table table-bordered table-sm text-center table-hover',
                        loadingClass: 'loading',
                        ascendingIcon: 'bi bi-chevron-up',
                        descendingIcon: 'bi bi-chevron-down',
                        handleIcon: 'bi bi-list',
                    }
                },
                sortOrder: [
                    {
                        field: 'name',
                        sortField: 'name',
                        direction: 'asc'
                    }
                ],
                fields: [
                    {
                        dataClass: 'text-nowrap',
                        icon: 'zoom icon',
                        name: 'index',
                        title: '#',
                        titleClass: 'text-nowrap'
                    },
                    {
                        dataClass: 'text-nowrap',
                        icon: 'zoom icon',
                        name: 'name',
                        sortField: 'name',
                        title: 'Usuario',
                        titleClass: 'text-nowrap'
                    },
                    {
                        dataClass: 'text-nowrap',
                        icon: 'zoom icon',
                        name: 'email',
                        sortField: 'email',
                        title: 'Correo',
                        titleClass: 'text-nowrap'
                    },
                    {
                        dataClass: 'text-nowrap',
                        name: 'actions',
                        title: 'Acción'
                    },
                ],
                moreParams: {}
            }
        },
        methods: {
            handleDelete(user) {
                if (confirm('Eliminar usuario ' + user.name + '?')) {
                    axios.delete(this.route('admin.users.destroy', user))
                    .then(response => {
                        this.$toast.open({
                            message: 'Usuario eliminado correctamente',
                            type: 'success',
                            duration: 5000,
                            dismissible: true,
                            position: 'top-right'
                        })
                        this.$refs.vuetable.refresh()
                    }).catch(error => {
                        this.$toast.open({
                            message: 'El usuario seleccionado no se puede eliminar',
                            type: 'error',
                            duration: 5000,
                            dismissible: true,
                            position: 'top-right'
                        })
                    })
                }
            }
        },
        components: {
            Vuetable,
            'filter-input': FilterInput
        },
        events: {
            'filter-set' (filterText) {
                this.moreParams = {
                    search: filterText
                }
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            'filter-reset' () {
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            }
        }
    }
</script>